import { useTheme } from '@emotion/react';
import React from 'react';

import { Alert, Text } from '~/components/blocks';
import { AppointmentsYakumaruPrescriptionIdentificationResultStatus } from '~/graphql/generated/graphql';

type Props = {
  status: AppointmentsYakumaruPrescriptionIdentificationResultStatus;
};

export const PrescriptionIdentifyAlert = (props: Props) => {
  const { status } = props;
  const theme = useTheme();

  if (status === 'processing') {
    return (
      <Alert status="info" withIcon marginBottom={theme.space.m}>
        <Text size="s">処方箋画像を読み取り中です…</Text>
      </Alert>
    );
  }

  if (status === 'failed') {
    return (
      <Alert status="error" withIcon marginBottom={theme.space.m}>
        <Text size="s">処方箋画像の読み取りに失敗しました。薬師丸賢太にてご確認ください</Text>
      </Alert>
    );
  }

  if (status === 'finished') {
    return (
      <Alert status="success" withIcon marginBottom={theme.space.m}>
        <Text size="s">薬師丸賢太にて読み取り済</Text>
      </Alert>
    );
  }
};
